var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-01526e06-f354-4bd6-9e69-1b76305db92f",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1006.96 970.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-91db18d9-26ef-4509-9fc8-c9d413b00bdb",
    d: "M964.77,550.26h-65.17v-294.04c0-23.32-18.89-42.19-42.19-42.19h-311.72V42.19c0-23.32-18.89-42.19-42.19-42.19s-42.19,18.87-42.19,42.19v171.83H149.56c-23.3,0-42.19,18.87-42.19,42.19v294.04H42.19c-23.3,0-42.19,18.87-42.19,42.19v336.24c0,23.32,18.89,42.19,42.19,42.19h922.57c23.3,0,42.19-18.87,42.19-42.19v-336.24c0-23.32-18.89-42.19-42.19-42.19ZM191.75,298.41h623.46v251.85H191.75v-251.85ZM922.57,886.5H84.39v-251.85h838.18v251.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthIcon);
export default __webpack_public_path__ + "static/media/BirthIcon.0d306d58b2720cf1659fb7d3845cf2df.svg";
export { ForwardRef as ReactComponent };